import { render } from "./PdfGeneration.vue?vue&type=template&id=274ff4dd&scoped=true"
import script from "./PdfGeneration.vue?vue&type=script&lang=js"
export * from "./PdfGeneration.vue?vue&type=script&lang=js"

import "./PdfGeneration.vue?vue&type=style&index=0&id=274ff4dd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274ff4dd"]])

export default __exports__